import { render } from "./Physiotherapy.vue?vue&type=template&id=40a2c3e2&scoped=true"
import script from "./Physiotherapy.vue?vue&type=script&lang=js"
export * from "./Physiotherapy.vue?vue&type=script&lang=js"

import "./Physiotherapy.vue?vue&type=style&index=0&id=40a2c3e2&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a2c3e2"]])

export default __exports__